import {
  Title as DefaultTitle,
  Modal as DefaultModal,
} from '@getinapp/appetizer';
import styled, { css } from 'styled-components';

export const Title = styled(DefaultTitle)`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large} !important;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  `}
`;

export const Email = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    margin: 1rem 0;
    font-weight: bold;
    font-size: ${theme.font.sizes.small};
  `}
`;

export const Modal = styled(DefaultModal)`
  background: white;
`;

export const BackButton = styled.p`
  margin-top: 1.5rem;
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;

    &:hover {
      cursor: pointer;
    }
    span {
      margin-right: 1rem;
    }
  `}
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
`;
